import React from 'react';
import PropTypes from 'prop-types';

import Button from '$partials/ui/button';
import Logo from '$partials/icons/logo';
import Image from '$partials/media/image';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleAthlete = ({
    avatar,
    defaultSport,
    location,
    name,
    stravaLink
}) => {
    return (
        <div className='w-full flex flex-wrap my-30 md:my-60 sm:flex-row-reverse'>
            <div className='w-full sm:w-8/12 md:w-7/12 px-10 sm:px-20 sm:mr-w-2/12 md:mr-w-1/12'>
                <div className='bg-white flex flex-wrap justify-between p-20 md:p-30 rounded'>
                    <div className='flex flex-row w-full sm:w-auto'>
                        <div
                            className='bg-cover rounded-full w-[46px] h-[46px] mr-20'
                            style={{backgroundImage: `url(${avatar.src})`}}
                            title={avatar.title}/>
                        <div className='flex flex-col'>
                            <p className='type-style-8'>
                                {name}
                            </p>
                            <div className='flex items-center type-style-7 text-dark-grey'>
                                <div
                                    className='mr-5'
                                    style={{
                                        fontSize: '10px',
                                        width: `${(defaultSport?.icon?.width / defaultSport?.icon?.height)}em` ,
                                        maxWidth: '100%'
                                    }}>
                                    <Image
                                        {...defaultSport?.icon}
                                        className='grayscale brightness-50'
                                        isSVG={true}/>
                                </div>
                                {location}
                            </div>
                        </div>
                    </div>

                    <Button
                        as='a'
                        className='mt-20 sm:mt-0 flex self-start items-center bg-orange text-white rounded type-style-7  px-20 py-15'
                        href={stravaLink}
                        renderIcon={<Logo />}>
                        Follow on
                    </Button>
                </div>
            </div>
        </div>
    );

};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleAthlete.propTypes = {
    avatar: PropTypes.object,
    defaultSport: PropTypes.object,
    location: PropTypes.string,
    name: PropTypes.string,
    stravaLink: PropTypes.string,
};

export default ModuleAthlete;
